import { Snackbar, Alert } from '@mui/material';
import { SNACKBAR_POSITION } from '../../theme/formStyles';

/**
 * Standardized application snackbar with consistent positioning
 *
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether snackbar is open
 * @param {Function} props.onClose - Close handler
 * @param {string} props.message - Message to display
 * @param {string} props.severity - Alert severity ('success', 'error', 'warning', 'info')
 * @param {number} props.autoHideDuration - Auto hide duration in ms (default: 6000)
 * @param {Object} props.anchorOrigin - Position override (default: bottom center)
 */
const AppSnackbar = ({
  open,
  onClose,
  message,
  severity = 'info',
  autoHideDuration = 6000,
  anchorOrigin = SNACKBAR_POSITION,
  ...rest
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose?.(event, reason);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      {...rest}
    >
      <Alert
        severity={severity}
        onClose={handleClose}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackbar;
